import { ImageBackground } from "@/components/ui/custom/image-background";
import { VideoBackground } from "@/components/ui/custom/video-background";
import { useHeroCarousel } from "./useHeroCarousel";

const BACKGROUND_DURATIONS = {
  video: 10000,
  image: 10000,
} as const;

export const getBackgroundDuration = (slide: {
  videoUrl?: string;
  staticImageUrl?: string;
}) => {
  if (slide.videoUrl) return BACKGROUND_DURATIONS.video;
  if (slide.staticImageUrl) return BACKGROUND_DURATIONS.image;
  return 10000;
};

export const CarouselBackgrounds = () => {
  const { slides, currentIndex, videoReplay } = useHeroCarousel();
  const currentSlide = slides[currentIndex];

  if (!currentSlide) return null;

  return (
    <div className="absolute inset-0 transition-opacity duration-1000 ease-in-out">
      {currentSlide.videoUrl ? (
        <VideoBackground
          key={`${currentSlide.videoUrl}-${videoReplay}`}
          videoUrl={currentSlide.videoUrl}
        />
      ) : currentSlide.staticImageUrl ? (
        <ImageBackground
          key={currentSlide.staticImageUrl}
          staticImageUrl={currentSlide.staticImageUrl}
        />
      ) : null}
    </div>
  );
};
